import React from 'react';
import { INTRO_DATA_EN, INTRO_DATA_SK } from '../../../constants/2023/intro';
import { FadeInWhenVisible } from '../../../utils/fade-in';

import './intro-25.scss';

export const Intro25: React.FC<{ language: 'en' | 'sk' }> = ({ language }) => {
  const introData = language === 'en' ? INTRO_DATA_EN : INTRO_DATA_SK;

  const intentionText =
    language === 'en' ? (
      <>
        <h3>
          <b>
            The 5th Conservative Summit will take place on Saturday, November 8, 2025, at the
            Historic Building of the National Council of the Slovak Republic at Župné nám. 12 in
            Bratislava.
          </b>
        </h3>
        The Conservative Summit is a gathering of Christian and conservative leaders and
        personalities from politics, culture, churches, civil society, media, academia and business.
        <br />
        <br />
        The Conservative Summit is non-partisan and a unique opportunity to build good relations and
        an atmosphere of cooperation across the conservative spectrum at national, European and
        international level.
        <br />
        <br />
        The Conservative Summit's ambition is to be the respected international ideas conference for
        Christian conservatism.
      </>
    ) : (
      <>
        <h3>
          <b>
            5. Konzervatívny summit sa uskutoční v sobotu, 8. novembra 2025 v Historickej budove NR
            SR na Župnom nám. 12 v Bratislave.
          </b>
        </h3>
        Konzervatívny summit je stretnutie kresťanských a konzervatívnych lídrov a osobností z
        oblasti politiky, kultúry, cirkví, občianskej spoločnosti, médií, akademickej obce a
        podnikateľskej sféry.
        <br />
        <br />
        Konzervatívny summit má nadstranícky charakter a je jedinečnou príležitosťou na budovanie
        dobrých vzťahov a atmosféry spolupráce v konzervatívnom spektre na národnej, európskej i
        medzinárodnej úrovni.
        <br />
        <br />
        Ambíciou Konzervatívneho summitu je byť rešpektovanou medzinárodnou ideovou konferenciou
        kresťanského konzervativizmu.
      </>
    );

  return (
    // <FadeInWhenVisible>
    <div className="Intro25" id="cs-introduction">
      <img className="Intro25-image" alt="intro" src="./hands_up.jpg" />
      <div className="Intro25-contentContainer">
        <div className="Intro25-content">
          <div className="Intro25-intention">
            <h1 className="Intro25-header">{introData.header}</h1>
            <div className="Intro25-text">
              <p>{intentionText}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </FadeInWhenVisible>
  );
};
